import type { Regimen } from "./types.ts";
import {
  BREAKFAST_CARBS,
  SNACK_CARBS,
  MAIN_CARBS,
  DINNER_CARBS,
  FULL_PROTEINS,
  DINNER_PROTEINS,
  SNACK_PROTEINS,
  GYM_LUNCH_PROTEINS,
  FRUITS,
  FATS,
  VEGETABLES_FRESH,
  VEGETABLES_SMALL,
  EGG_YOLK_NOTE,
  GELATIN_NOTE,
} from "./options.ts";

export const gymRegimen: Regimen = {
  id: "gym",
  name: "Días con Entrenamiento (Gym)",
  badge: "G",
  description: "Régimen para días de entrenamiento de fuerza en gimnasio",
  trainingTime: "5/6 PM",
  meals: [
    {
      name: "breakfast",
      label: "Desayuno",
      choices: [
        {
          category: "carb",
          pick: 1,
          canRepeat: false,
          options: BREAKFAST_CARBS,
        },
        {
          category: "fruit",
          pick: 1,
          canRepeat: false,
          options: FRUITS,
        },
        {
          category: "protein",
          pick: 4,
          canRepeat: true,
          note: EGG_YOLK_NOTE,
          options: FULL_PROTEINS,
        },
        {
          category: "fat",
          pick: 1,
          canRepeat: false,
          options: FATS,
        },
      ],
    },
    {
      name: "mid-morning",
      label: "Media Mañana",
      choices: [
        {
          category: "fruit",
          pick: 1,
          canRepeat: false,
          options: FRUITS,
        },
      ],
    },
    {
      name: "lunch",
      label: "Almuerzo",
      choices: [
        {
          category: "carb",
          pick: 2,
          canRepeat: true,
          options: MAIN_CARBS,
        },
        {
          category: "protein",
          pick: 1,
          canRepeat: false,
          options: GYM_LUNCH_PROTEINS,
        },
        {
          category: "vegetable",
          pick: 1,
          canRepeat: false,
          options: VEGETABLES_FRESH,
        },
        {
          category: "fat",
          pick: 2,
          canRepeat: true,
          options: FATS,
        },
      ],
    },
    {
      name: "pre-workout",
      label: "Pre Entreno",
      choices: [
        {
          category: "carb",
          pick: 2,
          canRepeat: true,
          options: SNACK_CARBS,
        },
        {
          category: "protein",
          pick: 2,
          canRepeat: true,
          note: GELATIN_NOTE,
          options: SNACK_PROTEINS,
        },
      ],
    },
    {
      name: "dinner",
      label: "Cena / Post Entreno",
      choices: [
        {
          category: "carb",
          pick: 2,
          canRepeat: true,
          options: DINNER_CARBS,
        },
        {
          category: "protein",
          pick: 5,
          canRepeat: true,
          note: EGG_YOLK_NOTE,
          options: DINNER_PROTEINS,
        },
        {
          category: "vegetable",
          pick: 1,
          canRepeat: false,
          optional: true,
          options: VEGETABLES_SMALL,
        },
        {
          category: "fat",
          pick: 2,
          canRepeat: true,
          options: FATS,
        },
      ],
    },
  ],
};
